module.exports = __webpack_public_path__ + "static/media/down.cbde3aa1.svg";